<template>
    <div>
        <HeaderBar/>
        <div class="auth-wrapper auth-v2 ">
            <b-row class="auth-inner m-0">
                <div class="w-100 d-flex flex-column ">
                    <HeaderBar/>
                    <div class="mt-4  ">
                        <!-- Basic Module -->
                        <div class="d-flex justify-content-center align-items-center mb-1 mt-3 ">
                            <div class="title">Datos Reproductivos</div>
                        </div>
                        <div class="d-flex flex-wrap justify-content-center">
                            <b-row class="ml-1 mr-1">
                                <b-col
                                cols="12"
                                >
                                    <b-card class="text-center" @click="navigateTo('basic-healthreproductionmale')">
                                        <b-avatar
                                        class="mb-1"
                                        variant="primary"
                                        size="100"
                                        >
                                        <b-img width="80px" 
                                               src="@/assets/images/ganImage/icons/male.png"
                                        />
                                        </b-avatar>
                                        <div class="truncate">
                                            <h2 class="mb-25 font-weight-bolder small-font-card">
                                                Macho
                                            </h2>
                                        </div>
                                    </b-card>
                                </b-col>
                                <b-col
                                cols="12"
                                >
                                    <b-card class="text-center" @click="navigateTo('basic-healthreproductionfemale')">
                                        <b-avatar
                                        class="mb-1"
                                        variant="primary"
                                        size="100"
                                        >
                                        <b-img width="80px" 
                                               src="@/assets/images/ganImage/icons/female.png"
                                        />
                                        </b-avatar>
                                        <div class="truncate">
                                            <h2 class="mb-25 font-weight-bolder small-font-card">
                                                Hembra
                                            </h2>
                                        </div>
                                    </b-card>
                                </b-col>
                            </b-row>
                        </div>
                    </div>
                </div>
                <ControlMenu />
            </b-row>
        </div>
    </div>
</template>

<script>
import ControlMenu from '@/components/ControlMenu.vue'
import HeaderBar from '@/components/HeaderBar.vue'
import {BRow, BCol, BLink, BImg, BForm, BButton, BCard, BAvatar} from 'bootstrap-vue';
export default {
    components:{
        BRow,
        BCol,
        BLink,
        BImg,
        BForm,
        BButton,
        BCard, 
        BAvatar,
        ControlMenu,
        HeaderBar
    },
    data() {
        return {

        }
    },
    methods:{
        navigateTo(routeName){
            this.$router.push({name:routeName});
        }
    }
}
</script>

<style lang="scss">
.buttonTitle {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
}

.title {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
}
@import '@core/scss/vue/pages/page-auth.scss';
</style>